import React, { useEffect } from "react";
import {
  IThemeConfig,
  useTheme,
  getConfig,
  PageDescription,
  PageTitle,
} from "../../../../_start/layout/core";
import { BrandingSetupPage } from "./BrandingSetupPage";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";

const defaultPageConfig = getConfig();
const dashboardPageConfig: Partial<IThemeConfig> = {
  aside: {
    ...defaultPageConfig.aside,
    display: true,
    primaryDisplay: true,
    secondaryDisplay: false,
    toggle: true,
    content: "menu",
  },
  toolbar: {
    ...defaultPageConfig.toolbar,
    display: false,
  },
  sidebar: {
    ...defaultPageConfig.sidebar,
    display: false,
  },
};

export function BrandingSetupPageWrapper() {
  const { setTheme } = useTheme();
  const location = useLocation();
  const state = location.state as { projectTitle: string; projectID: string; projectDescription?: string; userID: string; projectMotivation?: string };
  const { projectTitle, projectID, userID } = state;
  const projectDescription = state.projectDescription || "";
  const projectMotivation = state.projectMotivation || "";
  // Refresh UI after config updates
  useEffect(() => {
    setTheme(dashboardPageConfig);
    return () => {
      setTheme(defaultPageConfig);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <BrandingSetupPage userID={userID} projectTitle={projectTitle} projectID={projectID} projectDescription={projectDescription} projectMotivation={projectMotivation} />
      {/* Adds a link to edit the project details */}
      <Link
      className="mt-5"
      data-kt-menu-dismiss="true"
      title="Edit Project Details"
      to="/project"
      state={{
        projectTitle: projectTitle,
        projectID: projectID,
        projectDescription: projectDescription,
        userID: userID
      }}>
       back to Project Dashboard
      </Link>
      <PageTitle>{projectTitle}</PageTitle>
      <PageDescription>{projectDescription}</PageDescription>
    </>
  );
}
